import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';

export default function PushNotificationBanner({ open, onEnable, onDismiss }) {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <SnackbarContent
        style={{ backgroundColor: '#0d9488', color: '#fff', minWidth: 320 }}
        message={
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <NotificationsActiveIcon style={{ marginRight: 8 }} />
            Get desktop alerts when something needs your attention.
          </span>
        }
        action={[
          <Button
            key="enable"
            size="small"
            style={{ color: '#fff', fontWeight: 600 }}
            onClick={onEnable}
          >
            Enable
          </Button>,
          <IconButton
            key="close"
            size="small"
            aria-label="dismiss"
            style={{ color: '#fff' }}
            onClick={onDismiss}
          >
            <CloseIcon fontSize="small" />
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
}
